import { render, staticRenderFns } from "./KimsaSegmented.vue?vue&type=template&id=6ebc6a6c&scoped=true"
import script from "./KimsaSegmented.vue?vue&type=script&lang=js"
export * from "./KimsaSegmented.vue?vue&type=script&lang=js"
import style0 from "./KimsaSegmented.vue?vue&type=style&index=0&id=6ebc6a6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ebc6a6c",
  null
  
)

export default component.exports